import React from 'react';

const Attests: React.FC = () => {
  return (
    <span>attesten!</span>
  )
}

export default Attests;
